import { ITrangThaiKhoActions } from "../../action-types/quan-ly-kho/ITrangThaiKhoActionTypes";
import { ITrangThaiKhoReducer } from "../../reducer-model/quan-ly-kho/ITrangThaiKhoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ITrangThaiKhoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    trangThaiKhos: []
}

export const trangThaiKhoReducer = (state: ITrangThaiKhoReducer = iniState, action: ITrangThaiKhoActions): ITrangThaiKhoReducer => {
    switch (action.type) {
        case "TRANG_THAI_KHO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "TRANG_THAI_KHO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                trangThaiKhos: action.payload
            }
        case "TRANG_THAI_KHO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "TRANG_THAI_KHO_CLEAR_DATA":
            return {
                ...state,
                trangThaiKhos: []
            }
        default:
            return state;
    }
}
